declare global {
  var __API_URL__: string | undefined;
}

function isStagingApiUrl(apiUrl: string | undefined): boolean {
  return apiUrl?.includes("staging.elolink.tech") ?? false;
}

export function StagingBanner() {
  if (!isStagingApiUrl(globalThis.__API_URL__)) return null;

  return (
    <div
      aria-label="STAGING"
      style={{
        position: "fixed",
        right: "0.75rem",
        bottom: "0.75rem",
        zIndex: 60,
        border:
          "1px solid color-mix(in srgb, var(--login-accent) 42%, transparent)",
        borderRadius: "0.375rem",
        background: "var(--login-surface)",
        boxShadow: "0 8px 24px rgb(15 23 42 / 0.14)",
        color: "var(--login-accent)",
        fontFamily: "'DM Sans', sans-serif",
        fontSize: "0.6875rem",
        fontWeight: 700,
        letterSpacing: "0",
        lineHeight: 1,
        padding: "0.375rem 0.5rem",
        pointerEvents: "none",
      }}
    >
      STAGING
    </div>
  );
}
